const applyFilters = (items, filters, filterConfig) =>
  Object.entries(items)
    // eslint-disable-next-line no-unused-vars
    .filter(([key, item]) =>
      Object.entries(filters).every(([filterKey, filterValue]) => {
        if (!filterValue) return true;

        const config = filterConfig[filterKey];
        if (!config) return true;

        const itemValue = config.getValue(item);
        return config.match(itemValue, filterValue);
      }),
    )
    .reduce(
      (acc, [key, item]) => ({
        ...acc,
        [key]: item,
      }),
      {},
    );

export const filterBuyers = (buyersToFilter, filters) => {
  const filterConfig = {
    mlsDeals: {
      getValue: (buyer) => buyer.organization.buyerConfig.allowMlsDeals,
      match: (value, filterVal) => value === filterVal,
    },
    preDeals: {
      getValue: (buyer) =>
        buyer.organization.buyersAppFeatureFlags.preDeals.isActive,
      match: (value, filterVal) => value === filterVal,
    },
    pool: {
      getValue: (buyer) => buyer.matchedBuyBox.pool,
      match: (value, filterVal) => !filterVal || filterVal === value,
    },
    propertyTypes: {
      getValue: (buyer) => buyer.matchedBuyBox.propertyTypes,
      match: (value, filterVal) =>
        filterVal.length === 0 ||
        filterVal.some((type) => value.includes(type)),
    },
  };

  return applyFilters(buyersToFilter, filters, filterConfig);
};
